export default "__VITE_ASSET__BUiriHcu__"